/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';

import { IInvoiceMappedData } from '../../interfaces';

import { InvoicePrintTemplateComponent } from './InvoicePrintTemplate.component';

const InvoicePrintTemplate: React.FC = () => {
  document.body.className = 'print-template';

  const [data, setData] = useState<IInvoiceMappedData | null>(null);

  useEffect(() => {
    const handler = (event: MessageEvent): void => {
      if (event.origin !== window.location.origin) return;

      if (event.data?.payload) {
        setData(event.data.payload);
      }
    };

    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, []);

  // check if all fonts & images are loaded
  useEffect(() => {
    if (!data) return;

    const ready = async (): Promise<void> => {
      await document.fonts?.ready;

      await Promise.all(
        Array.from(document.images).map((img) =>
          img.complete
            ? Promise.resolve()
            : new Promise((res) => {
                img.onload = res;
                img.onerror = res;
              }),
        ),
      );

      window.dispatchEvent(new Event('READY_TO_PRINT'));
    };

    ready();
  }, [data]);

  return <>{data && <InvoicePrintTemplateComponent data={data} />}</>;
};

export default InvoicePrintTemplate;
